import type { ReactNode } from "react";
import { useContext, useMemo } from "react";
import { AuthContext } from "./auth-context";
import { DotcomAuthContext } from "../context";
import type { DotcomAuthSession } from "../types";
import { enhanceUserData } from "./enhance-user-data";

export { AuthProvider } from "./auth-provider";
export { AuthContext } from "./auth-context";
export { enhanceUserData } from "./enhance-user-data";
export const LegacyAuthBridge = ({ children }: { children: ReactNode }) => {
  const { IS_TOKEN_STORED, PROFILE, IS_CREDIT_PROFILE_USER, TOKEN } =
    useContext(AuthContext);

  const customerDetails = PROFILE?.customerDetails;
  const isCreditProfile = Boolean(IS_CREDIT_PROFILE_USER);
  const isSignedIn =
    customerDetails && Boolean(IS_TOKEN_STORED?.stored && customerDetails);

  const value = useMemo<DotcomAuthSession>(
    () => ({
      accessToken:
        TOKEN?.token && "accessToken" in TOKEN.token
          ? TOKEN.token.accessToken
          : undefined,
      customerDetails: isSignedIn
        ? enhanceUserData({ customerDetails, isCreditProfile })
        : undefined,
      error: null,
      status: isSignedIn ? "authenticated" : "unauthenticated",
    }),
    [TOKEN, isSignedIn, customerDetails, isCreditProfile],
  );

  return (
    <DotcomAuthContext.Provider value={value}>
      {children}
    </DotcomAuthContext.Provider>
  );
};
